
function requestAPI(page, limit, name, categoryId, producerId, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}product?page=${page}&limit=${limit}&name=${name}&category_id=${categoryId}&producer_id=${producerId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionListProduct(page, limit, name, categoryId, producerId) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'LIST_PRODUCT_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(page, limit, name, categoryId, producerId, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'LIST_PRODUCT_SUCCESS',
        page: result.data.page,
        pages: result.data.pages,
        payload: result.data.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'LIST_PRODUCT_FAILURE',        
    error: error    
  })
}